export var UserActionType;
(function (UserActionType) {
    UserActionType["ADD_USERS"] = "ADD_USERS";
    UserActionType["ADD_USER_INFO"] = "ADD_USER_INFO";
    UserActionType["UPDATE_USER_INFO"] = "UPDATE_USER_INFO";
    UserActionType["USER_INFO"] = "USER_INFO";
    UserActionType["CLEAR_ALL_DATA_USER"] = "CLEAR_ALL_DATA_USER";
    UserActionType["OPEN_EDIT_PROFILE"] = "OPEN_EDIT_PROFILE";
    UserActionType["CLOSE_EDIT_PROFILE"] = "CLOSE_EDIT_PROFILE";
    UserActionType["ADD_PEOPLE_INFO"] = "ADD_PEOPLE_INFO";
    UserActionType["HAS_MORE_DATA_PEOPLE"] = "HAS_MORE_DATA_PEOPLE";
    UserActionType["NOT_MORE_DATA_PEOPLE"] = "NOT_MORE_DATA_PEOPLE";
    UserActionType["REQUEST_PAGE_PEOPLE"] = "REQUEST_PAGE_PEOPLE";
    UserActionType["LAST_USER_PEOPLE"] = "LAST_POST_PEOPLE";
})(UserActionType || (UserActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/userActionType.ts
// module id = 295
// module chunks = 50